<template>
  <loading v-if="loading" />
  <error-messages
    v-else-if="!loading && errorMessages.length > 0"
    :messages="errorMessages"
  />
  <b-row v-else>
    <b-col sm="12" md="6" xl="4">
      <b-card>
        <b-row>
          <b-col lg="12" class="d-flex flex-column align-items-center">
            <b-avatar size="150px" :src="profilePicture" alt="عکس پروفایل" />
            <span class="mt-3" v-if="form.firstName && form.lastName">
              {{ form.firstName }}&nbsp;{{ form.lastName }}
            </span>
          </b-col>
          <b-col lg="12">
            <div class="d-flex justify-content-center mt-3">
              <b-button
                variant="info"
                :to="`/admin/user/${this.$route.params.userId}/edit`"
              >
                ویرایش اطلاعات
              </b-button>
              <!-- <b-button
                variant="danger"
                :to="`/admin/user/${this.$route.params.userId}/change-password`"
              >
                تغییر رمز عبور
              </b-button> -->
            </div>
          </b-col>
        </b-row>
      </b-card>
    </b-col>
    <b-col sm="12" md="6" xl="8">
      <b-card style="margin-bottom: 30px" title="مشخصات" title-tag="h5">
        <b-row>
          <b-col
            v-for="(item, i) in profileList"
            :key="i"
            sm="6"
            md="12"
            xl="6"
          >
            <div class="d-flex align-items-center mb-3">
              <b-icon
                :icon="item.icon"
                font-scale="2"
                variant="warning"
                class="ml-3"
              />
              <div class="d-flex flex-column">
                <div class="d-flex flex-column">
                  <span
                    class="display: flex"
                    style="font-size: 12px; color: #8c8c8c; margin-bottom: 10px"
                  >
                    {{ item.type }}
                  </span>
                  <span class="d-flex">
                    {{ item.value }}
                  </span>
                </div>
              </div>
            </div>
          </b-col>
          <b-col cols="12" xl="6">
            <div class="d-flex align-items-center mb-3">
              <b-icon
                icon="envelope-fill"
                font-scale="2"
                variant="warning"
                class="ml-3"
              />
              <div class="d-flex flex-column">
                <div class="d-flex flex-column">
                  <span
                    class="d-flex"
                    style="font-size: 12px; color: #8c8c8c; margin-bottom: 10px"
                  >
                    ایمیل
                  </span>
                  <span>
                    {{ form.email }}
                  </span>
                </div>
                <b-button
                  v-if="form.email && !form.isEmailConfirmed"
                  size="sm"
                  variant="outline-warning"
                  @click="emailVerificationClicked"
                >
                  تایید ایمیل
                </b-button>
              </div>
            </div>
          </b-col>
          <b-col cols="12" xl="6">
            <div class="d-flex align-items-center mb-3">
              <b-icon
                icon="telephone-fill"
                font-scale="2"
                variant="warning"
                class="ml-3"
              />
              <div class="d-flex flex-column">
                <div class="d-flex flex-column">
                  <span
                    style="font-size: 12px; color: #8c8c8c; margin-bottom: 10px"
                  >
                    تلفن همراه
                  </span>
                  <span>
                    {{ form.phoneNumber }}
                  </span>
                </div>
                <b-button
                  v-if="form.phoneNumber && !form.isPhoneNumberConfirmed"
                  size="sm"
                  variant="outline-warning"
                  @click="mobileVerificationClicked"
                >
                  تایید تلفن همراه
                </b-button>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import { userDetailsAdmin } from "@/services/user";
import Loading from "@/components/Loading/Loading.vue";
import ErrorMessages from "@/components/ErrorMessages/ErrorMessages.vue";

export default {
  components: { Loading, ErrorMessages },
  name: "UserProfile",
  data() {
    return {
      loading: false,
      errorMessages: [],
      profileList: [
        {
          id: "username",
          type: "نام کاربری",
          icon: "person-fill",
          value: ""
        },
        {
          id: "registerDateTime",
          type: "تاریخ ثبت نام",
          icon: "calendar2-check-fill",
          value: ""
        },
        {
          id: "lastLoginDateTime",
          type: "تاریخ آخرین لاگین",
          icon: "calendar-date",
          value: ""
        },
        {
          id: "balance",
          type: "اعتبار حساب",
          icon: "cash",
          value: ""
        }
      ],
      form: {
        firstName: "",
        lastName: "",
        email: "",
        isEmailConfirmed: false,
        phoneNumber: "",
        isPhoneNumberConfirmed: false
      },
      profilePicture: ""
    };
  },
  mounted() {
    this.getUserDetailsAdmin();
  },
  methods: {
    getUserDetailsAdmin: async function() {
      this.loading = true;
      const [error, data] = await userDetailsAdmin(this.$route.params.userId);
      if (error) {
        this.loading = false;
        this.errorMessages = error;
      } else {
        if (data.apiStatus === 200) {
          let newForm = { ...this.form };
          newForm.firstName = data.apiData.firstName;
          newForm.lastName = data.apiData.lastName;
          newForm.email = data.apiData.email;
          newForm.phoneNumber = data.apiData.phoneNumber;
          newForm.isEmailConfirmed = data.apiData.isEmailConfirmed;
          newForm.isPhoneNumberConfirmed = data.apiData.isPhoneNumberConfirmed;
          this.form = { ...newForm };

          this.profilePicture = data.apiData.profilePicture;
          let temp = [...this.profileList];
          temp.map(item => {
            switch (item.id) {
              case "username":
                item["value"] = data.apiData.username;
                break;
              case "balance":
                item["value"] = data.apiData.balance;
                break;
              case "registerDateTime":
                item["value"] = data.apiData.registerDateTime;
                break;
              case "lastLoginDateTime":
                item["value"] = data.apiData.lastLoginDateTime;
                break;
            }
          });
          this.profileList = [...temp];
          this.loading = false;
        } else {
          this.loading = false;
          this.errorMessages = data.apiErrors;
        }
      }
    },
    emailVerificationClicked: function() {
      alert("email verification clicked");
    },
    mobileVerificationClicked: function() {
      alert("mobile verification clicked");
    }
  }
};
</script>
